module.exports = __webpack_public_path__ + "static/media/Inverted.73a56e4c.svg";